module.exports = __webpack_public_path__ + "img/blue100.47594f0f.png";